/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule4_CondInputs */

const tr_landing_pricerules_mock_rule4_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HB Buybox rakibi fiyat düşürürse`)
};

const en_landing_pricerules_mock_rule4_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HB Buybox rival lowers price`)
};

const de_landing_pricerules_mock_rule4_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HB-Buybox-Konkurrent senkt Preis`)
};

const ru_landing_pricerules_mock_rule4_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конкурент в HB Buybox снижает цену`)
};

/**
* | output |
* | --- |
* | "HB Buybox rival lowers price" |
*
* @param {Landing_Pricerules_Mock_Rule4_CondInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule4_cond = /** @type {((inputs?: Landing_Pricerules_Mock_Rule4_CondInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule4_CondInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule4_cond(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule4_cond(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule4_cond(inputs)
	return tr_landing_pricerules_mock_rule4_cond(inputs)
});